// import SideBarDropdownLayout from '../../components/manager/SidebarDropdown'
// import logo from '../../assets/images/logo.png';
// import { useState } from 'react';
// import { NavLink } from 'react-router-dom';
// import { ReactComponent as DashboardIcon } from '../../components/svgs/dashboardicon.svg';
// import { ReactComponent as OrdersIcon } from '../../components/svgs/ordersicon.svg';
// import { ReactComponent as CustomersIcon } from '../../components/svgs/customersicon.svg';
// import { ReactComponent as ServicesIcon } from '../../components/svgs/servicesIcon.svg';
// import { ReactComponent as EmployeesIcon } from '../../components/svgs/employeesIcon.svg';
// import { ReactComponent as ReportsIcon } from '../../components/svgs/reportsIcon.svg';
// import { ReactComponent as SettingsIcon } from '../../components/svgs/settingsIcon.svg';
// import { ReactComponent as LogoutIcon} from '../../components/svgs/logouticon.svg';
// // import { ReactComponent as InvoiceIcon } from '../../components/svgs/padlockIcon.svg';
// import { ReactComponent as SalesIcon } from '../../components/svgs/padlockIconGrey.svg';
// import { ReactComponent as GratuityIcon } from '../../components/svgs/padlockIconGrey.svg';
// import {ReactComponent as DropdownIcon} from '../../components/svgs/dropdownIcon.svg';



// const ManagerSidebar = () => {
//     const [showReportsDropdown, setShowReportsDropdown] = useState(false);
  
//     const toggleReportsDropdown = () => {
//       setShowReportsDropdown(!showReportsDropdown);
//     };
  
//     return (
//       <div className="manager-sidebar">
//         <section className=''>
//         <SideBarDropdownLayout userInitials={'RG'} userName={'Rachel Green'} role={'Manager'}/>
//         </section>
//         <section className='mt-6 flex flex-col gap-6'>
//             <NavLink exact to="/manager" className="manager-sidebar-link" activeClassName="active-link">
//                 <DashboardIcon className="manager-sidebar-icon" />
//                 <span className="manager-sidebar-text">Dashboard</span>
//             </NavLink>
//             <NavLink to="/manager/orders" className="manager-sidebar-link" activeClassName="active-link">
//                 <OrdersIcon className="manager-sidebar-icon" />
//                 <span className="manager-sidebar-text">Orders</span>
//             </NavLink>
//             <NavLink to="/manager/customers" className="manager-sidebar-link" activeClassName="active-link">
//                 <CustomersIcon className="manager-sidebar-icon" />
//                 <span className="manager-sidebar-text">Customers</span>
//             </NavLink>
//             <NavLink to="/manager/services" className="manager-sidebar-link" activeClassName="active-link">
//                 <ServicesIcon className="manager-sidebar-icon" />
//                 <span className="manager-sidebar-text">Services</span>
//             </NavLink>
//             <NavLink to="/manager/employees" className="manager-sidebar-link" activeClassName="active-link">
//                 <EmployeesIcon className="manager-sidebar-icon" />
//                 <span className="manager-sidebar-text">Employees</span>
//             </NavLink>
//             <div className="manager-reports-dropdown">
//             <div className="manager-sidebar-link" onClick={toggleReportsDropdown}>
//                 <ReportsIcon className="manager-sidebar-icon" />
//                 <span className="manager-sidebar-text">Reports</span>
                
//                 <DropdownIcon className='ml-52'/>
//             </div>
//             {showReportsDropdown && (
//                 <div className="manager-reports-submenu">
//                 <NavLink to="/manager/reports/invoicing" className="manager-sidebar-sublink" activeClassName="active-link">
//                         <span className="manager-sidebar-subtext">Invoices</span>
//                 </NavLink>
//                 <NavLink to="/reports/sales" className="manager-sidebar-sublink" activeClassName="active-link">
//                     <span className="manager-sidebar-subtext">Sales</span>
//                     <SalesIcon className="manager-sidebar-subicon sales-icon"/>
//                 </NavLink>
//                 <NavLink to="/reports/gratuity" className="manager-sidebar-sublink" activeClassName="active-link">
//                     <span className="manager-sidebar-subtext">Gratuity</span>
//                     <GratuityIcon className="manager-sidebar-subicon" />
//                 </NavLink>
//                 </div>
//             )}
//             </div>
//             <NavLink to="/manager/settings" className="manager-sidebar-link" activeClassName="active-link">
//                 <SettingsIcon className="manager-sidebar-icon" />
//                 <span className="manager-sidebar-text">Settings</span>
//             </NavLink>
//             <section className='mt-28'>
//                 <NavLink to="/logout" className="manager-sidebar-link" activeClassName="active-link">
//                     <LogoutIcon className="manager-sidebar-icon" />
//                     <span className="manager-sidebar-text">Logout</span>
//                 </NavLink>
//                 <NavLink to="/login" className="manager-sidebar-link" activeClassName="active-link">
//                     <img src={logo} alt="laundry Squared Logo"  className='site-logo'/>
//                 </NavLink>
//             </section>
            
//         </section>
        
//       </div>
//     );
//   };

// export default ManagerSidebar;

import React, { useState } from 'react';
import logo from '../../assets/images/logo.png';
import {ReactComponent as DashboardIcon} from '../../components/svgs/dashboardicon.svg';
import { ReactComponent as OrdersIcon } from '../../components/svgs/ordersicon.svg';
import { ReactComponent as CustomersIcon } from '../../components/svgs/customersicon.svg';
import { ReactComponent as ServicesIcon } from '../../components/svgs/servicesIcon.svg';
import { ReactComponent as EmployeesIcon } from '../../components/svgs/employeesIcon.svg';
import { ReactComponent as ReportsIcon } from '../../components/svgs/reportsIcon.svg';
import { ReactComponent as SettingsIcon } from '../../components/svgs/settingsIcon.svg';
import { ReactComponent as LogoutIcon} from '../../components/svgs/logouticon.svg';
import {ReactComponent as DropdownIcon} from '../../components/svgs/dropdownIcon.svg';
import { ReactComponent as SalesIcon } from '../../components/svgs/padlockIconGrey.svg';
import { ReactComponent as GratuityIcon } from '../../components/svgs/padlockIconGrey.svg';
import SideBarDropdownLayout from '../../components/manager/SidebarDropdown'
import { Link, useLocation } from 'react-router-dom';


const ManagerSidebar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const links = [
    { label: 'Dashboard', icon: DashboardIcon, href: '/manager/dashboard' },
    { label: 'Orders', icon: OrdersIcon, href: '/manager/orders' },
    { label: 'Customers', icon: CustomersIcon, href: '/manager/customers' },
    { label: 'Services', icon: ServicesIcon, href: '/manager/services' },
    { label: 'Employees', icon: EmployeesIcon, href: '/manager/employees' },
  
    { label: 'Reports', icon: ReportsIcon, href: '#', isDropdown: true },
    { label: 'Settings', icon: SettingsIcon, href: '/manager/settings' },
    // { label: 'Logout', icon: LogoutIcon, href: '/logout' },
    
  ];

  const dropdownLinks = [
    { label: 'Invoices', href: '/manager/reports/invoicing' },
    { label: 'Sales', icon: SalesIcon, href: '#' },
    { label: 'Gratuity', icon: GratuityIcon, href: '#' },
  ];

  return (
    <div className="manager-sidebar">
      <section className="manager-sidebar-dropdown-layout">
        <SideBarDropdownLayout userInitials={'RG'} userName={'Rachel Green'} role={'Manager'} />
      </section>
      <nav className="mt-10">
        <ul>
          {links.map((link, index) => (
            <li
              key={index}
              className={`${
                link.href === location.pathname || location.pathname.startsWith(link.href)
                  ? 'active'
                  : ''
              }`}
            >
              <Link
                to={link.href}
                onClick={link.isDropdown ? toggleDropdown : null}
                className={`manager-sidebar-link ${
                  link.href === location.pathname || location.pathname.startsWith(link.href)
                    ? 'active'
                    : ''
                }`}
              >
                <span className={`icon ${link.href === location.pathname ? 'active' : ''}`}>
                  <link.icon />
                </span>
                <span className="label">{link.label}</span>
                {link.isDropdown && (
                  <span className={`dropdown-icon ${isDropdownOpen ? 'open' : ''}`}>
                    <DropdownIcon />
                  </span>
                )}
              </Link>
              {link.isDropdown && isDropdownOpen && (
                <ul className="dropdown-menu">
                  {dropdownLinks.map((dropdownLink, dropdownIndex) => (
                    <li
                      key={dropdownIndex}
                      className={`${
                        location.pathname === dropdownLink.href ? 'active' : ''
                      }`}
                    >
                      <Link
                        to={dropdownLink.href}
                        className={`manager-sidebar-sublink ${
                          location.pathname === dropdownLink.href ? 'active' : ''
                        }`}
                      >
                        <span className="manager-sidebar-subtext">{dropdownLink.label}</span>
                        {dropdownLink.icon && (
                          <span className="icon mt-2">
                            <dropdownLink.icon className="ml-10" />
                          </span>
                        )}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </nav>
      <section className="mt-44">
        <div className="flex gap-6 mb-6 logout-label-section">
          <LogoutIcon />
          <Link to={'/'} className="logout-label">
            Logout
          </Link>
        </div>
        <Link to={'/login'}>
          <div className="logo">
            <img src={logo} alt="laundry Squared Logo" className="site-logo" />
          </div>
        </Link>
        
      </section>
    </div>
  );
};

export default ManagerSidebar;